var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBusinessTypeIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 70,
    height: 70,
    viewBox: "0 0 70 70",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.5,
    x2: 0.5,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#00ff7f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#006934"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_6265",
    "data-name": "Group 6265",
    transform: "translate(-920 -2043.999)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6263",
    "data-name": "Group 6263",
    transform: "translate(920 2044)",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_42",
    "data-name": "Ellipse 42",
    transform: "translate(0 0)",
    fill: "#121212",
    stroke: "#fff",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 35,
    cy: 35,
    r: 35,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 35,
    cy: 35,
    r: 34.5,
    fill: "none"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Icon_metro-chart-bars",
    "data-name": "Icon metro-chart-bars",
    d: "M2.571,26.992H33.419v3.856H2.571ZM6.427,19.28h3.856v5.784H6.427Zm5.784-7.712h3.856v13.5H12.211Zm5.784,5.784h3.856v7.712H17.995ZM23.779,5.784h3.856v19.28H23.779Z",
    transform: "translate(937.43 2060.216)",
    fill: "url(#linear-gradient)"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBusinessTypeIcon);
export default __webpack_public_path__ + "static/media/business_type_icon.a7e02541e1ea593449af981923c16b6b.svg";
export { ForwardRef as ReactComponent };